import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { api } from "@/lib/api";
import PropertyCard from "@/components/property/PropertyCard";
import BrandedLoader from "@/components/common/BrandedLoader";

export default function Collection() {
  const { slug } = useParams();
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get(`/collections/${slug}`).then(({ data }) => setData(data));
  }, [slug]);

  if (!data) return <BrandedLoader />;

  return (
    <div data-testid="collection-page">
      <Helmet>
        <title>{`${data.name} · Vyagram Experiences`}</title>
        <meta name="description" content={data.description} />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={`${data.name} · Vyagram`} />
        <meta property="og:description" content={data.description} />
        {data.image && <meta property="og:image" content={data.image} />}
        <meta name="twitter:card" content="summary_large_image" />
        {data.image && <meta name="twitter:image" content={data.image} />}
      </Helmet>
      <section className="relative isolate overflow-hidden">
        <img src={data.image} alt={data.name} className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-noir/85 to-forest/50" />
        <div className="relative mx-auto max-w-7xl px-4 py-24 sm:px-6 sm:py-32 lg:px-10 lg:py-40">
          <p className="font-accent text-lg text-gold uppercase tracking-[0.2em]">Collection</p>
          <h1 className="mt-3 font-display text-4xl text-parchment sm:text-6xl">{data.name}</h1>
          <p className="mt-3 text-xl text-gold/90 italic">{data.tagline}</p>
          <p className="editorial-body mt-5 max-w-2xl !text-parchment/85">{data.description}</p>
        </div>
      </section>
      <section className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-10">
        <p className="text-sm text-noir/70">{data.properties?.length} stays</p>
        <div className="mt-6 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {data.properties?.map((p) => (<PropertyCard key={p.slug} p={p} />))}
        </div>
      </section>
    </div>
  );
}
